import React from 'react';

import { EnergyResultStep } from './types';
import { EnergyResultStepTemplate } from './EnergyResultStepTemplate';
import { getCssVariable } from '../../../utils';

const primaryColor = getCssVariable('--color-primary') || '#680ddb';
const greenColor = getCssVariable('--color-green-base') || '#09c25a';
const redColor = getCssVariable('--color-red-base') || '#f34720';

const fontsizel = getCssVariable('--font-size-l') || '20px';

export const energyResultSteps: EnergyResultStep[] = [
  {
    step: 1,
    title: <span>Here's your energy rhythm!</span>,
    canGoBack: false,
    canGoNext: true,
    animatedTime: 0,
    disableAnimation: true,
    useIdealCircadian: false,
    explanation:
      'This is based on your circadian rhythm, dictated by sleep, light exposure, and stress. ',
    children: (data) => <EnergyResultStepTemplate data={data} showGrid showCustomLabels />,
  },

  {
    step: 2,
    title: <span>Here's how to read your energy.</span>,
    canGoBack: true,
    canGoNext: true,
    animatedTime: 5000,
    disableAnimation: false,
    useIdealCircadian: false,
    explanation: (peakTime: string[]) =>
      `Your peak energy zones are around ${peakTime.join(
        ' and '
      )}. We’ll use this to plan your day more efficiently.`,
    children: (data) => (
      <EnergyResultStepTemplate
        data={data}
        visiblePeaksDips={['wakeup_low', 'morning_high', 'morning_low', 'evening_high']}
        showPhaseBlockTimeLabels
      />
    ),
  },
];
